import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container align-center" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-6 col-sm-2 text-left" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col-6 col-sm-2 text-left" }
const _hoisted_6 = { class: "row justify-content-center" }
const _hoisted_7 = { class: "col-6 col-sm-3 m-4" }
const _hoisted_8 = { class: "row justify-content-center" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "text-danger col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "h3 m-4 text-center container" }, "Registration Interface", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-3 col-sm-1 text-right" }, " UserName ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userName) = $event)),
          placeholder: "Enter Your Email Address"
        }, null, 512), [
          [_vModelText, $setup.userName]
        ])
      ])
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "row text-danger justify-content-center m-2" }, " (emails only) ", -1)),
    _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-3 col-sm-1 text-right" }, " Password ", -1)),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
          placeholder: "Create Account Password"
        }, null, 512), [
          [_vModelText, $setup.password]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("div", _hoisted_7, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("div", { id: "validateNotRobot" }, null, -1),
        _createElementVNode("br", null, null, -1)
      ]))], 512), [
        [_vShow, $setup.isValidateNotRobotShown]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
      _withDirectives(_createElementVNode("button", {
        class: _normalizeClass(["col-sm-1 col-4 btn btn-primary m-4", {'disabled':$setup.isBtnCreateUserLoginDisabled, 'btn-grey':$setup.isBtnCreateUserLoginDisabled}]),
        id: "btnCreateUserLogin",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.createUserLogin && $setup.createUserLogin(...args)))
      }, "Create User", 2), [
        [_vShow, $setup.isBtnCreateUserLoginShown]
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("span", _hoisted_10, _toDisplayString($setup.registrationStatus), 1)
    ])
  ]))
}